import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import SEOHead from '@/components/SEOHead';

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead 
        title={t('legal.privacy.title')} 
        description={t('legal.privacy.metaDescription')}
        path="/privacy-policy"
      />
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <Link to="/">
            <Button variant="ghost" className="mb-6">
              <ArrowLeft className="w-4 h-4 mr-2" />
              {t('common.back')}
            </Button>
          </Link>

          <h1 className="text-3xl font-bold text-foreground mb-6">{t('legal.privacy.title')}</h1>
          <p className="text-sm text-muted-foreground mb-8">{t('legal.privacy.lastUpdated')}: 02/01/2026</p>

          <div className="prose prose-sm dark:prose-invert max-w-none space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.privacy.sections.intro.title')}</h2>
              <p className="text-muted-foreground">{t('legal.privacy.sections.intro.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.privacy.sections.dataCollected.title')}</h2>
              <p className="text-muted-foreground">{t('legal.privacy.sections.dataCollected.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.privacy.sections.purpose.title')}</h2>
              <p className="text-muted-foreground">{t('legal.privacy.sections.purpose.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.privacy.sections.sharing.title')}</h2>
              <p className="text-muted-foreground">{t('legal.privacy.sections.sharing.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.privacy.sections.security.title')}</h2>
              <p className="text-muted-foreground">{t('legal.privacy.sections.security.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.privacy.sections.rights.title')}</h2>
              <p className="text-muted-foreground">{t('legal.privacy.sections.rights.content')}</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">{t('legal.privacy.sections.contact.title')}</h2>
              <p className="text-muted-foreground">
                {t('legal.privacy.sections.contact.content')}{' '}
                <a href="mailto:support@tedmonitor.eu" className="text-primary hover:underline">
                  support@tedmonitor.eu
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
